import React from 'react'
import Page, {
  DescriptionText,
  StyledFormContainer,
} from 'Event/template/Townhall/Login/Page'
import {useGuestVariables} from 'Event'
import {TitleText} from 'Event/template/Townhall/Login/Title'
import Configurable from 'organization/Event/Configurable'
import OfflineContentConfig from 'Event/template/Townhall/EventOfflinePage/OfflineContentConfig'
import {OfflinePageProps} from 'Event/JoinArea/OfflinePage'
import {useTownhallTemplate} from 'Event/template/Townhall'

export default function EventOfflinePage(props: OfflinePageProps) {
  const v = useGuestVariables()

  return (
    <Page isPreview={props.isPreview || false}>
      <Configurable
        aria-label="event offline content config"
        dataTestId="event offline config"
      >
        <OfflineContentConfig />
        <StyledFormContainer>
          <OfflineTitle>{v(props.title)}</OfflineTitle>
          <DescriptionText>
            <div dangerouslySetInnerHTML={{__html: v(props.description)}} />
          </DescriptionText>
        </StyledFormContainer>
      </Configurable>
    </Page>
  )
}

function OfflineTitle(props: {children: string}) {
  const {textColor, offlinePage, login} = useTownhallTemplate()

  if (!props.children) {
    return null
  }

  return (
    <TitleText
      titleColor={offlinePage.titleTextColor ?? login.welcome.color}
      textColor={textColor}
      fontSize={offlinePage.titleFontSize ?? login.welcome.fontSize}
    >
      {props.children}
    </TitleText>
  )
}
